import UsersGroupIcon from './component'

export default UsersGroupIcon
